var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1.33334C4.32666 1.33334 1.33333 4.32668 1.33333 8.00001C1.33333 11.6733 4.32666 14.6667 8 14.6667C11.6733 14.6667 14.6667 11.6733 14.6667 8.00001C14.6667 4.32668 11.6733 1.33334 8 1.33334ZM7.5 5.33334C7.5 5.06001 7.72666 4.83334 8 4.83334C8.27333 4.83334 8.5 5.06001 8.5 5.33334V8.66668C8.5 8.94001 8.27333 9.16668 8 9.16668C7.72666 9.16668 7.5 8.94001 7.5 8.66668V5.33334ZM8.61333 10.92C8.58 11.0067 8.53333 11.0733 8.47333 11.14C8.40666 11.2 8.33333 11.2467 8.25333 11.28C8.17333 11.3133 8.08666 11.3333 8 11.3333C7.91333 11.3333 7.82666 11.3133 7.74666 11.28C7.66666 11.2467 7.59333 11.2 7.52666 11.14C7.46666 11.0733 7.41999 11.0067 7.38666 10.92C7.35333 10.84 7.33333 10.7533 7.33333 10.6667C7.33333 10.58 7.35333 10.4933 7.38666 10.4133C7.41999 10.3333 7.46666 10.26 7.52666 10.1933C7.59333 10.1333 7.66666 10.0867 7.74666 10.0533C7.90666 9.98668 8.09333 9.98668 8.25333 10.0533C8.33333 10.0867 8.40666 10.1333 8.47333 10.1933C8.53333 10.26 8.58 10.3333 8.61333 10.4133C8.64666 10.4933 8.66666 10.58 8.66666 10.6667C8.66666 10.7533 8.64666 10.84 8.61333 10.92Z",
    fill: "#C90000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/info-circle.f16a4f0b.svg";
export { ForwardRef as ReactComponent };